import ButtonsContainer from 'components/buttons/buttonsContainer'
import Carousel from 'components/carousel/carousel'
import Counter from 'contexts/counter'
import { useHeadbandContext } from 'contexts/headband'
import { useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { getItem } from 'store/localeStorage'
import './accueil.scss'
import {
   buttons1,
   buttons2_assemblage,
   buttons2_moulage,
   buttons3_assemblage,
   buttons3_moulage,
   buttons4_assemblage,
   buttons4_moulage,
} from './accueilButtons'
export default function Accueil() {
   const dispatch = useDispatch()
   const { setCounter, counterDefault } = useContext(Counter)
   const { setHeadband } = useHeadbandContext()
   const lang = useSelector((state: any) => state.languageReducer.language)

   useEffect(() => {
      setCounter(counterDefault)
      setHeadband('')
   }, [])

   const addCrumb = {
      title: lang === 'fr' ? 'Visiteurs' : 'Visitors',
      page: '/accueil/visiteur',
   }

   useEffect(() => {
      dispatch({ type: 'fr' })
   }, [])

   return (
      <>
         <div id='home' className='flex column around'>
            <div id='carousel'>
               <div style={{ width: 1080, height: 607 }}>
                  <Carousel />
               </div>
               <Link to='/accueil/visiteur/' className='flex center column' id='btnToVisitor'>
                  <img src={`${process.env.PUBLIC_URL}/img/picto_visiteurs_-_2023.png`} alt='' />
               </Link>
            </div>
            <ButtonsContainer buttons={buttons1} />
            <div id='buttons2'>
               <ButtonsContainer
                  buttons={
                     getItem('totem') === 'Assemblage' ? buttons2_assemblage : buttons2_moulage
                  }
               />
            </div>
            <div id='buttons2'>
               <ButtonsContainer
                  buttons={
                     getItem('totem') === 'Assemblage' ? buttons3_assemblage : buttons3_moulage
                  }
               />
            </div>
            <div id='buttons3'>
               <ButtonsContainer
                  start={getItem('totem') === 'Moulage'}
                  buttons={
                     getItem('totem') === 'Assemblage' ? buttons4_assemblage : buttons4_moulage
                  }
               />
            </div>
            <div id='bandeau'>
               <span className='txt'>
                  Retrouvez toutes les informations pratiques et l’accès à vos demandes en quelques
                  clics&nbsp;&nbsp;•&nbsp;&nbsp;
               </span>
               <span className='txt'>
                  Retrouvez toutes les informations pratiques et l’accès à vos demandes en quelques
                  clics&nbsp;&nbsp;•&nbsp;&nbsp;
               </span>
            </div>
         </div>
      </>
   )
}
